import _ from 'lodash'

class Sticky {

    constructor(props) {
        this.props = props
        this.init()
    }

    init() {

        if ( typeof this.props.elem === 'undefined' ) return

        this.header = document.querySelector(this.props.elem)
        this.stickyTop = document.querySelectorAll(this.props.stickyTop)

        this.addStickyScroll()

    }

    addStickyScroll() {
        if ( this.header == null ) return
        
        window.addEventListener('scroll', _.throttle(() => {
            if(window.pageYOffset > this.header.offsetTop) {
                this.header.classList.add('sticky')
            } else {
                this.header.classList.remove('sticky')
            }
        }, 250))

        if ( this.stickyTop.length > 0 ) {
            this.stickyTop.forEach(sticky => {
                let adminbar = document.body.classList.contains('admin-bar') ? 32 : 0
                const headerHeight = this.header.offsetHeight + adminbar
                const offsetTop = sticky.offsetTop - this.header.offsetHeight
                const offsetLeft = sticky.offsetLeft
                const height = sticky.offsetHeight
                const width = sticky.offsetWidth + 1                

                const stickyElm = sticky.querySelector(':scope > *')

                window.addEventListener('scroll',() => {
                    if (window.pageYOffset > offsetTop) {
                        sticky.classList.add('sticky')
                        sticky.style.position = 'relative'
                        sticky.style.height = `${height}px`

                        stickyElm.style.position = 'fixed'
                        stickyElm.style.width = `${width }px`
                        stickyElm.style.top = `${headerHeight}px`
                        stickyElm.style.left = `${offsetLeft}px`
                        stickyElm.style.zIndex = '100'
                    } else {
                        sticky.classList.remove('sticky')
                        sticky.style.height = ''
                        sticky.style.position = ''

                        stickyElm.style.position = 'relative'
                        stickyElm.style.width = ''
                        stickyElm.style.top = ''
                        stickyElm.style.left = ''
                        stickyElm.style.zIndex = 'auto'
                    }
                })
            });
        }
    }
}

export default Sticky